import {Presenter} from '../../Support/with_presenter';
import {WorkoutsService} from '../../Network/WorkoutsService';
import {loadingResponse, NetworkResult} from '../../Network/NetworkResult';
import {PartialWorkout} from '../../Models/PartialWorkout';

export class WorkoutIndexPresenter implements Presenter {
    public result: NetworkResult<PartialWorkout[]> = loadingResponse();

    constructor(private workoutService: WorkoutsService) {}

    public async mount(): Promise<void> {
        this.result = await this.workoutService.all();
    }

    public unmount(): void {
        /* Noop */
    }
}
